import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white shadow-sm">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <div className="flex items-center gap-3">
              {/* Logo SVG */}
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* Carré orange en haut à gauche */}
                <rect x="2" y="2" width="15" height="15" fill="#FF9933" rx="2"/>
                {/* Carré orange en bas à droite */}
                <rect x="23" y="23" width="15" height="15" fill="#FF9933" rx="2"/>
                {/* Forme D stylisée en bleu */}
                <path d="M20 8 L32 8 C36 8 38 12 38 16 L38 24 C38 28 36 32 32 32 L20 32 L20 8 Z" fill="#1E3A5F"/>
                <circle cx="27" cy="20" r="6" fill="white"/>
              </svg>
              
              {/* Texte LD Digital */}
              <div className="flex items-baseline gap-1">
                <span className="text-2xl font-bold tracking-tight" style={{ fontFamily: "'Inter', sans-serif", color: '#FF9933' }}>LD</span>
                <span className="text-xl font-semibold tracking-tight" style={{ fontFamily: "'Inter', sans-serif", color: '#1E3A5F' }}>Digital</span>
              </div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="text-[#1E3A5F] hover:text-[#FF9933] transition-colors duration-200 font-medium"
            >
              Comment ça marche
            </button>
            <button
              onClick={() => scrollToSection('advantages')}
              className="text-[#1E3A5F] hover:text-[#FF9933] transition-colors duration-200 font-medium"
            >
              Pourquoi moi
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="text-[#1E3A5F] hover:text-[#FF9933] transition-colors duration-200 font-medium"
            >
              Portfolio
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#FF9933] hover:bg-[#E68A2E] text-white transition-all duration-200"
            >
              Contact
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[#1E3A5F] p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden pb-4">
            <nav className="flex flex-col space-y-3">
              <button
                onClick={() => scrollToSection('how-it-works')}
                className="text-[#1E3A5F] hover:text-[#FF9933] transition-colors duration-200 font-medium text-left"
              >
                Comment ça marche
              </button>
              <button
                onClick={() => scrollToSection('advantages')}
                className="text-[#1E3A5F] hover:text-[#FF9933] transition-colors duration-200 font-medium text-left"
              >
                Pourquoi moi
              </button>
              <button
                onClick={() => scrollToSection('portfolio')}
                className="text-[#1E3A5F] hover:text-[#FF9933] transition-colors duration-200 font-medium text-left"
              >
                Portfolio
              </button>
              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-[#FF9933] hover:bg-[#E68A2E] text-white transition-all duration-200 w-full"
              >
                Contact
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
